import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";

import founder1 from "../../assets/images/founder.jpg";
import founder2 from "../../assets/images/ceo.jpg";

const teamMembers = [
  {
    name: "Founder name",
    title: "Founder & CEO",
    img: founder1,
    linkedin: "#",
  },
  {
    name: "Founder name",
    title: "Founder & CEO",
    img: founder2,
    linkedin: "#",
  },
];

const MeetOurTeam = () => {
  const sectionRef = useRef(null);
  const headingRef = useRef(null);
  const subheadingRef = useRef(null);
  const teamCardsRef = useRef([]);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Animate heading and subheading first
      gsap.fromTo(
        [headingRef.current, subheadingRef.current],
        {
          opacity: 0,
          y: 30,
          scale: 0.95,
        },
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.9,
          ease: "power3.out",
          stagger: 0.2,
        }
      );

      // Animate team cards with stagger
      gsap.fromTo(
        teamCardsRef.current,
        {
          opacity: 0,
          y: 40,
          scale: 0.9,
        },
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 1,
          ease: "power3.out",
          stagger: 0.25,
          delay: 0.3, // Start after heading/subheading
        }
      );
    }, sectionRef);

    return () => {
      ctx.revert();
    };
  }, []);

  return (
    <section ref={sectionRef} className="bg-[#F7F7F7] py-[60px] md:py-[80px]">
      <div className="container-custom">
        <div className="flex flex-col md:flex-col lg:flex-row md:items-start md:gap-12">
          {/* Left Text Section */}
          <div className="flex-1 mb-[40px] md:mb-0">
            <h2 
              ref={headingRef} 
              className="font-[LTWave] font-medium text-[28px] md:text-[44px] leading-[109%] tracking-[-1%] text-[#222] mb-4"
            >
              Meet Our Team
            </h2>
            <p 
              ref={subheadingRef} 
              className="text-[#4B4B4B] font-inter font-normal text-[16px] leading-[150%] tracking-normal max-w-[420px]"
            >
              At Agastya Agro, our experienced and passionate team works together
              to deliver reliable, farmer-first solutions that support agriculture
              across India.
            </p>
            {/* Mobile only button */}
            <button className="block md:hidden mt-[24px] w-[174px] h-[48px] rounded-[250px] border border-[#000] text-[#000] font-inter text-[16px] opacity-100">
              Know About Us
            </button>
          </div>

          {/* Right Cards Section */}
          <div className="flex flex-col sm:flex-row gap-6">
            {teamMembers.map((member, index) => (
              <div
                key={index}
                ref={el => {
                  if (el) teamCardsRef.current[index] = el;
                }}
                className="relative rounded-[20px] overflow-hidden w-full max-w-[376px] h-full max-h-[371px] md:max-h-[477px] shadow-md group hover:shadow-lg transition-all duration-200"
              >
                <div className="overflow-hidden">
                  <img
                    src={member.img}
                    alt={`Portrait of ${member.name}, ${member.title}`}
                    className="w-full h-full object-cover transition-all duration-700 ease-in-out group-hover:scale-105"
                  />
                </div>
                {/* Overlay */}
                <div className="absolute bottom-0 left-0 right-0 px-[30px] pb-[30px] flex items-center justify-between bg-gradient-to-t from-black/70 to-transparent">
                  <div>
                    <h3 className="font-[LTWave] font-bold text-[24px] leading-[100%] tracking-[2%] text-white">
                      {member.name}
                    </h3>
                    <p className="font-inter font-normal text-[16px] md:text-lg text-white">
                      {member.title}
                    </p>
                  </div>
                  {member.linkedin && member.linkedin !== '#' && (
                    <a
                      href={member.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-white w-8 h-8 flex items-center justify-center rounded-md"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none">
                        <rect x="0.5" width="40" height="40" rx="7" fill="white"/>
                        <path d="M15.3815 13.0352C15.3815 14.1594 14.5163 15.0703 13.4485 15.0703C12.3807 15.0703 11.5156 14.1594 11.5156 13.0352C11.5156 11.9117 12.3807 11 13.4485 11C14.5163 11 15.3815 11.9117 15.3815 13.0352ZM15.3971 16.6984H11.5V29.7234H15.3971V16.6984ZM21.6183 16.6984H17.7462V29.7234H21.6191V22.8861C21.6191 19.0844 26.3182 18.7735 26.3182 22.8861V29.7234H30.2059V21.4762C30.2059 15.0614 23.252 15.295 21.6183 18.4527V16.6984Z" fill="#1C1C1C"/>
                      </svg>
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MeetOurTeam;